import { Filter } from './filter.model';

export enum NodeType {
  PARENT,
  FILTER
}

export interface TreeNode {
  name?: string;
  children?: TreeNode[];
  expanded?: boolean;
  checked?: boolean;
  step?: number;
  stepsArray?: any[];
  maxValue?: number;
  minRange?: number;
  maxRange?: number;
  filter?: Filter;
  icon?: string;
  rowNumber?: number;
  type: NodeType;
}
